import { PropTypes } from 'prop-types';

const AccionaCheckButton = ({ active, updateActive, msg }) => {
  return (
    <>
      <input
        type="radio"
        hidden
        className="timeSelection ui-checkboxradio ui-helper-hidden-accessible"
        value="0"
      />
      <label
        onClick={() => updateActive(!active)}
        className={
          active
            ? 'ui-checkboxradio-label ui-corner-all ui-button ui-widget ui-checkboxradio-radio-label ui-checkboxradio-checked ui-state-active'
            : 'ui-checkboxradio-label ui-corner-all ui-button ui-widget ui-checkboxradio-radio-label ui-state-hover'
        }
      >
        {msg}
      </label>
    </>
  );
};

AccionaCheckButton.propTypes = {
  active: PropTypes.bool.isRequired,
  updateActive: PropTypes.func,
  msg: PropTypes.string.isRequired,
};

AccionaCheckButton.defaultProps = {
  updateActive: () => {},
};

export default AccionaCheckButton;
